import r from "sweetalert2";
function s(e) {
  if (!e) {
    console.error("Options is required.");
    return;
  }
  const n = typeof e == "string" ? { titleText: e } : e;
  return r.fire({
    icon: "success",
    toast: !0,
    timer: 2e3,
    didOpen: (t) => {
      t.addEventListener("mouseenter", r.stopTimer), t.addEventListener("mouseleave", r.resumeTimer);
    },
    position: "top",
    showConfirmButton: !1,
    ...n
  });
}
function u(e) {
  if (!e) {
    console.error("Options is required.");
    return;
  }
  const n = typeof e == "string" ? { titleText: e } : e;
  return r.fire({
    icon: "info",
    toast: !0,
    timer: 3e3,
    timerProgressBar: !0,
    didOpen: (t) => {
      t.addEventListener("mouseenter", r.stopTimer), t.addEventListener("mouseleave", r.resumeTimer);
    },
    showConfirmButton: !1,
    ...n
  });
}
function f(e) {
  if (!e) {
    console.error("Options is required.");
    return;
  }
  const n = typeof e == "string" ? { titleText: e } : e;
  return r.fire({
    icon: "warning",
    backdrop: !1,
    confirmButtonColor: "#66b1ff",
    timer: 5e3,
    timerProgressBar: !0,
    didOpen: (t) => {
      t.addEventListener("mouseenter", r.stopTimer), t.addEventListener("mouseleave", r.resumeTimer);
    },
    ...n
  });
}
function c(e) {
  if (!e) {
    console.error("Options is required.");
    return;
  }
  const n = typeof e == "string" ? { titleText: e } : e;
  return r.fire({
    icon: "error",
    allowOutsideClick: !1,
    confirmButtonColor: "#66b1ff",
    ...n
  });
}
function l(e) {
  if (!e) {
    console.error("Options is required.");
    return;
  }
  const n = typeof e == "string" ? { titleText: e } : e;
  return new Promise((t, o) => {
    r.fire({
      icon: "question",
      confirmButtonColor: "#66b1ff",
      showCancelButton: !0,
      reverseButtons: !0,
      allowOutsideClick: !1,
      ...n
    }).then((i) => {
      i.isConfirmed ? t(i) : o(i);
    });
  });
}
const d = { success: s, warning: f, info: u, error: c, confirm: l };
export {
  d as default
};
//# sourceMappingURL=sweetalert2-preset.mjs.map
